import { call, takeLatest } from 'redux-saga/effects';
import { DICOMViewerSlice } from '@restore/DICOMViewer/DICOMViewer.slice';
import { clinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { clinicalTrialInventorySlice } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';
import { dispatch, getUrlParams } from '@restore/helpers';
import { fetchISTasks, fetchISTasksContext } from '@api/isTasks';
import { fetchClinicalTrialContextWorker } from '@restore/clinicalTrialContext/clinicalTrialContext.saga';
import { fetchClinicalTrialInventoryWorker } from '@restore/clinicalTrialInventory/clinicalTrialInventory.saga';
import { SimpleViewerSlice } from '@restore/DICOMViewer/modes/SimpleViewer/SimpleViewer.slice';
import { fetchCommonDICOMResource } from '@api/DICOMResource';

const { fetchNeededDataSuccess, fetchNeededDataFailure } =
  DICOMViewerSlice.actions;

const { fetchClinicalTrialContext } = clinicalTrialContextSlice.actions;

const { fetchClinicalTrialInventory } = clinicalTrialInventorySlice.actions;

export function* fetchSimpleNeededDataWorker() {
  try {
    const { id: clinicalTrialId, taskId } = yield call(getUrlParams);
    if (!(clinicalTrialId && taskId)) {
      yield dispatch(
        fetchNeededDataFailure(new Error('Missing ctId or taskId'))
      );
      return;
    }
    yield call(
      fetchClinicalTrialContextWorker,
      fetchClinicalTrialContext(clinicalTrialId)
    );
    yield call(
      fetchClinicalTrialInventoryWorker,
      fetchClinicalTrialInventory(clinicalTrialId)
    );
    const { data } = yield call(fetchISTasksContext, clinicalTrialId, taskId);

    yield dispatch(SimpleViewerSlice.actions.setData(data));
    const tasksResponse: Awaited<ReturnType<typeof fetchISTasks>> = yield call(
      fetchISTasks,
      clinicalTrialId,
      {}
    );
    yield dispatch(
      SimpleViewerSlice.actions.setTasks(tasksResponse.data.content)
    );

    const dicomData: Awaited<ReturnType<typeof fetchCommonDICOMResource>> = yield call(
      fetchCommonDICOMResource,
      clinicalTrialId
    );
    yield dispatch(SimpleViewerSlice.actions.setDicomResource(dicomData.url));

    yield dispatch(fetchNeededDataSuccess(undefined));
  } catch (error) {
    yield dispatch(fetchNeededDataFailure(error as Error));
    console.error('fetchSimpleNeededDataWorker', error);
  }
}

export function* SimpleViewerSaga() {
  yield takeLatest(
    DICOMViewerSlice.actions.fetchNeededData.type,
    fetchSimpleNeededDataWorker
  );
}
